'use strict';
angular.module('noticeServiceModule', ['editNoticeTypeModule', 'MCPreviewForManuscriptsModule'])
    .factory('noticeService', ['$modal', '$q', 'trsHttpService', function ($modal, $q, trsHttpService) {
        return {
            editNoticeType: function (noticeType) {
                var defer = $q.defer();
                var modalInstance = $modal.open({
                    templateUrl: './MC/notice/service/editNoticeType/editNoticeType_tpl.html',
                    windowClass: 'editNoticeType-window',
                    backdrop: false,
                    controller: 'editNoticeTypeCtrl',
                    resolve: {
                        noticeType: function () {
                            return noticeType;
                        },
                    }
                });
                // 关闭弹窗
                modalInstance.result.then(function (result) {
                    defer.resolve(result);
                }, function () {
                    defer.reject('cancel');
                });
                return defer.promise;
            },
            MCpreviewForManu: function(draft) {
                var defer = $q.defer();
                var modalInstance = $modal.open({
                    templateUrl: './MC/notice/service/previewForManuscripts/previewForManu.html',
                    windowClass: 'MCpreviewForManu-window',
                    backdrop: false,
                    controller: 'MCPreviewForManuscriptsCtrl',
                    resolve: {
                        draft: function () {
                            return draft;
                        },
                    }
                });
                // 关闭弹窗
                modalInstance.result.then(function (result) {
                    defer.resolve(result);
                }, function () {
                    defer.reject('cancel');
                });
                return defer.promise;
            }
        };
    }]);
